export default __webpack_public_path__ + "static/media/ANEXO-II-LISTA-DE-DOCUMENTOS.e8765fc7.pdf";